import { createSlice } from "@reduxjs/toolkit";
import { getGlobalLivekitToken } from "./GlobalLivekitThunk";

const initialState ={
    globalLivekitMic: false,
    globalLivekitToken: null,
    error: null
}


const globalLivekitSlice = createSlice ({
    name: 'globalLivekit',
    initialState,
    reducers: {
        toggleGlobalLivekitMic: (state, action) => {
            // Avoid unnecessary state updates
            if (state.globalLivekitMic === !!action.payload) return;
            state.globalLivekitMic = !!action.payload;
        },
    },
    extraReducers:(builder) => {
        builder
        .addCase(getGlobalLivekitToken.fulfilled, (state, action) => {
            state.globalLivekitToken = action.payload.refreshToken
        })
        .addCase(getGlobalLivekitToken.rejected, (state, action) => {
            state.globalLivekitToken = null
            state.error = action.payload
        })
    }
})

export const {
    toggleGlobalLivekitMic,
} = globalLivekitSlice.actions




export default globalLivekitSlice.reducer